import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { normalizeSupabaseProjectUrl } from "./supabaseUrl";

const supabaseUrl = normalizeSupabaseProjectUrl(
  import.meta.env.VITE_SUPABASE_URL || "https://jmgoqpqyrnoamfjngcmy.supabase.co"
);
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY || "";

/**
 * Supabase 클라이언트 (Realtime Broadcast용)
 * VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY 환경변수 설정 필요
 */
export const supabase: SupabaseClient | null =
  supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;

const publicAnonAuthStorage = {
  getItem: (): string | null => null,
  setItem: (): void => {},
  removeItem: (): void => {},
};

/**
 * 공개 링크(가정통신문 응답 등) 전용. localStorage의 로그인 세션을 읽지 않아
 * 요청이 항상 anon 역할로 나가며, 로그인한 사용자도 RLS insert_anon 정책과 맞습니다.
 *
 * `createClient`를 여러 개 호출하면(예: 메인 client + public-only client) 브라우저 컨텍스트에서
 * GoTrueClient가 중복 생성되어 "Multiple GoTrueClient instances detected" 경고가 뜰 수 있습니다.
 * 이를 완화하기 위해 메인 클라이언트와 다른 storageKey를 지정합니다.
 */
export const supabasePublicAnon: SupabaseClient | null =
  supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: false,
          autoRefreshToken: false,
          detectSessionInUrl: false,
          storage: publicAnonAuthStorage,
          storageKey: "sb-foreducator-public-anon",
        },
      })
    : null;
